<div class="m-4">
  <div class="pitchin-icon pitchin-icon-close" (click)="close()"></div>
  <div class="row pb-4">
    <div class="col-12 d-flex align-items-center">
      <div class="mr-2">
        <div
          class="tw-inline-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-[#C2F0CA] tw-p-3"
        >
          <div
            class="tw-w-6 tw-h-6 pitchin-icon-deposit-arrow tw-align-baseline tw-text-[#4EAC5F]"
          ></div>
        </div>
      </div>
      <div class="font-weight-extrabold text-black deposit-title">
        {{ 'mysec.TopUp' | translate }}
      </div>
    </div>
  </div>
  <form (ngSubmit)="submit()" [formGroup]="form" [class.show-form-error]="showFormError">
    <div class="row pb-4">
      <div class="col-12 input-panel">
        <div class="input-label font-size-smaller">{{ 'mysec.amount' | translate }}</div>
        <div class="position-relative currency-panel w-100">
          <label for="deposit-input" class="tw-block currency text-primary">RM</label>
          <input
            id="deposit-input"
            type="text"
            class="form-control tw-mb-2"
            placeholder="0.00"
            [ngModel]="amount"
            formControlName="amount"
            digitOnly
            decimal="true"
            [pattern]="DoubleDecimalPattern"
          />
        </div>
        @if (
          showFormError && form.controls.amount.errors && form.controls.amount.hasError('pattern')
        ) {
          <div class="text-danger tw-mb-2 tw-text-xs tw-font-semibold">
            {{ 'Amount must be in valid format and not more than 2 decimal places.' | translate }}
          </div>
        }
        <div class="small-text tw-mb-2 available-balance">
          {{ 'mysec.minimumTopUp' | translate }}
          <b class="text-black">{{ MinimumDepositAmount | numberSuffix }}</b>
        </div>
        @if ((difference ?? 0) > 0) {
          <p class="small-text tw-mb-2 tw-text-primary tw-font-bold">{{ 'investment.suggestedTopUpToInvest' | translate: { amount: (difference | numberSuffix: { numberFormat: '1.2-2' }) } }}</p>
        }
      </div>
    </div>
    <div class="row justify-content-center pb-3">
      <div class="col-md-10">
        <button type="submit" class="btn btn-primary w-100">
          {{ 'common.continue' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
